import { Link } from 'react-router-dom';
import { Footer } from '@/components/Footer';

export default function MentionsLegales() {
    return (
        <div className="min-h-screen bg-slate-50 flex flex-col">
            <div className="flex-1 max-w-3xl mx-auto px-4 py-12 w-full">
                <Link to="/" className="text-emerald-600 text-sm font-medium hover:underline mb-6 inline-block">&larr; Retour à l'accueil</Link>
                <h1 className="text-3xl font-bold text-slate-900 mb-8">Mentions Légales</h1>

                <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-slate-100 space-y-6 text-sm text-slate-600 leading-relaxed">
                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">1. Éditeur du site</h2>
                        <p>Le site et la plateforme <strong>FidelRun</strong> sont édités par :</p>
                        <ul className="mt-2 space-y-1">
                            <li><strong>Raison sociale :</strong> SARL DEALRUN</li>
                            <li><strong>SIRET :</strong> 895 350 783 00018</li>
                            <li><strong>Code APE :</strong> 63.12Z</li>
                            <li><strong>Siège social :</strong> DEAL RUN, APT 7 Résidence ARKEA Sainte-Clotilde, 33 Boulevard du Mahatma Gandhi, 97490 Saint-Denis</li>
                            <li><strong>Téléphone :</strong> <a href="tel:0693463628" className="text-emerald-600 hover:underline">06 93 46 36 28</a></li>
                            <li><strong>Email :</strong> <a href="mailto:digirun974@gmail.com" className="text-emerald-600 hover:underline">digirun974@gmail.com</a></li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">2. Directeur de la publication</h2>
                        <p>Le directeur de la publication est le représentant légal de la SARL DEALRUN.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">3. Hébergement</h2>
                        <p>La plateforme FidelRun est hébergée par des prestataires tiers professionnels garantissant la sécurité et la disponibilité des données conformément aux normes en vigueur.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">4. Propriété intellectuelle</h2>
                        <p>L'ensemble des éléments constituant le site FidelRun (textes, graphismes, logiciels, images, vidéos, sons, plans, logos, marques, etc.) est la propriété exclusive de la SARL DEALRUN ou de ses partenaires. Toute reproduction, représentation, modification, publication, transmission ou dénaturation, totale ou partielle, du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit, est interdite sans l'autorisation écrite préalable de la SARL DEALRUN.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">5. Responsabilité</h2>
                        <p>La SARL DEALRUN s'efforce de fournir sur le site FidelRun des informations aussi précises que possible. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">6. Droit applicable</h2>
                        <p>Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-slate-800 mb-3">7. Contact</h2>
                        <p>Pour toute question relative aux mentions légales, vous pouvez nous contacter :</p>
                        <ul className="mt-2 space-y-1">
                            <li>Par téléphone : <a href="tel:0693463628" className="text-emerald-600 hover:underline">06 93 46 36 28</a></li>
                            <li>Par email : <a href="mailto:digirun974@gmail.com" className="text-emerald-600 hover:underline">digirun974@gmail.com</a></li>
                        </ul>
                    </section>
                </div>
            </div>
            <Footer />
        </div>
    );
}
